import { DebitCard, DebitCardProps, Icon } from '@branch-messenger/willow-ui'
import { InfoCircle, Pencil01 } from '@branch-messenger/willow-ui/icons'
import { useSuspenseQuery } from '@tanstack/react-query'

import { Alert, AlertBodyText } from '@/components/alert'
import { useAccountActions } from '@/containers/payouts/hooks/useAccountActions'
import { paymentProfileQueryOptions } from '@/queries/profile'
import { useFormattedOrgFees } from '@/selectors/organization'

import {
  PayoutMethodContainer,
  PayoutMethodInfoContainer,
  UpdatePayoutMethodButton,
} from './styles'

export const DirectCardInfo = () => {
  const { data: paymentProfileData } = useSuspenseQuery(
    paymentProfileQueryOptions
  )
  const { last4, network } =
    paymentProfileData?.branch_direct_card_account || {}

  const { data } = useFormattedOrgFees()
  const { baseFee, feePercentage, orgCoversAllFees } = data || {}
  const { updateLinkedCard } = useAccountActions()
  return (
    <PayoutMethodContainer>
      <PayoutMethodInfoContainer>
        <DebitCard
          last4={last4}
          status={'active'}
          cardBrand={network?.toLowerCase() as DebitCardProps['cardBrand']}
        />
        <UpdatePayoutMethodButton
          variant="pillFilled"
          color="tertiary"
          onClick={updateLinkedCard}
          iconRight={<Icon Icon={Pencil01} />}
        >
          Update Debit Card
        </UpdatePayoutMethodButton>
      </PayoutMethodInfoContainer>
      <Alert Icon={InfoCircle}>
        {orgCoversAllFees ? (
          <AlertBodyText>
            {'All payouts to your connected debit card will be sent at'}
            <AlertBodyText as="span" $bold>
              {' '}
              no cost.
            </AlertBodyText>
          </AlertBodyText>
        ) : (
          <AlertBodyText>
            {`All payouts to your connected debit card will incur a ${feePercentage} ${baseFee} fee off of the total amount.`}
          </AlertBodyText>
        )}
      </Alert>
    </PayoutMethodContainer>
  )
}
